var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn ml-0 p-0"},[_c('div',{staticClass:"back-btn",on:{"click":function($event){return _vm.goBack()}}},[_c('img',{staticClass:"img-fluid back-img",attrs:{"src":require("@/assets/img/icons/arrow-circle-right.svg"),"width":("" + _vm.width)}}),_vm._v(" "),_c('a',{staticClass:"font-weight-bold mt-n1"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8432cee2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIElements/BackButton.vue
// module id = null
// module chunks = 